"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceLocationId = exports.DeliveryBlockResourceLocationType = exports.BreakType = void 0;
var BreakType;
(function (BreakType) {
    BreakType[BreakType["Fixed"] = 0] = "Fixed";
    BreakType[BreakType["Flex"] = 1] = "Flex";
    BreakType[BreakType["Relative"] = 2] = "Relative";
})(BreakType || (exports.BreakType = BreakType = {}));
var DeliveryBlockResourceLocationType;
(function (DeliveryBlockResourceLocationType) {
    DeliveryBlockResourceLocationType[DeliveryBlockResourceLocationType["DRIVER_ADDRESS"] = 1] = "DRIVER_ADDRESS";
    DeliveryBlockResourceLocationType[DeliveryBlockResourceLocationType["TEAM_ADDRESS"] = 2] = "TEAM_ADDRESS";
    DeliveryBlockResourceLocationType[DeliveryBlockResourceLocationType["PARKING_SPOT"] = 3] = "PARKING_SPOT";
    DeliveryBlockResourceLocationType[DeliveryBlockResourceLocationType["VEHICLE_DEFAULT_PARKING"] = 4] = "VEHICLE_DEFAULT_PARKING";
    DeliveryBlockResourceLocationType[DeliveryBlockResourceLocationType["LAST_DRIVER_LOCATION"] = 5] = "LAST_DRIVER_LOCATION";
})(DeliveryBlockResourceLocationType || (exports.DeliveryBlockResourceLocationType = DeliveryBlockResourceLocationType = {}));
var ResourceLocationId;
(function (ResourceLocationId) {
    ResourceLocationId["DEPOT"] = "depot";
    ResourceLocationId["HOME"] = "home";
    ResourceLocationId["TASK"] = "task";
    ResourceLocationId["DRIVER_LOCATION"] = "driver_location";
})(ResourceLocationId || (exports.ResourceLocationId = ResourceLocationId = {}));
//# sourceMappingURL=delivery_block.js.map